import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dha_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('dha_token');
      localStorage.removeItem('dha_role');
      localStorage.removeItem('dha_name');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const loginUser = (data) => api.post('/auth/login', data);

// Doctors
export const getDoctors = () => api.get('/doctors');
export const addDoctor = (data) => api.post('/doctors', data);
export const updateDoctor = (id, data) => api.put(`/doctors/${id}`, data);
export const deleteDoctor = (id) => api.delete(`/doctors/${id}`);

// Patients / Registration
export const registerPatient = (data) => api.post('/register', data);
export const searchPatients = (q) => api.get(`/patients?q=${encodeURIComponent(q)}`);

// Visits / Daily List
export const getDailyList = (date) => api.get(`/visits${date ? `?date=${date}` : ''}`);

// Dashboard stats
export const getDashboardStats = () => api.get('/dashboard');

// Appointments
export const getAppointments = (params) => api.get('/appointments', { params });
export const createAppointment = (data) => api.post('/appointments', data);
export const cancelAppointment = (id) => api.delete(`/appointments/${id}`);
export const updateAppointmentStatus = (id, status) => api.patch(`/appointments/${id}/status`, { status });

// Reports
export const getReports = (from, to) => api.get('/reports', { params: { from, to } });

export default api;
